<template>
  <div class="product-filter-component">
    <filter-item v-for="(item, index) in filterBar"
                 :item="item"
                 :params="selectParams"
                 :key="index"
                 @filterTitle="handleFilterTitle"
                 @confirm="handleConfirm"
                 @reset="handleReset"
                 @delete="handleDelete"
    />
  </div>
</template>

<script>
  import { getProductFilterInfo } from '@/services/app';
  import FilterItem from '@/components/ProductFilter/components/item';

  export default {
    name: 'ProductFilter',
    components: {
      FilterItem,
    },
    props: {
      type: {
        type: String,
        required: true,
      },
      filterType: {
        type: String,
      },
      params: {
        type: String,
      },
    },
    data() {
      return {
        filterBar: [],
        filterResult: {},
        selectParams: [],
      };
    },
    watch: {
      params: {
        handler(val) {
          this.fetchProductFilterInfo(val);
        },
        deep: true,
      },
    },
    methods: {
      async fetchProductFilterInfo(params) {
        const data = await getProductFilterInfo({ type: this.type, filterType: this.filterType });

        this.filterBar = this.fetchFilterData(data.filterBar);
        this.selectParams = this.fetchParamsToArr(params);
        this.fetchParamsToObj(params);
      },

      fetchParamsToArr(params) {
        let selectOptions = [];
        if (params !== '') {
          selectOptions = params.split('&');
        }
        return selectOptions;
      },

      fetchParamsToObj(params) {
        const filterResult = {};
        if (params === '') return;
        params.split('&').forEach((item) => {
          const [key, value] = item.split('=');
          filterResult[key] = value;
        });
        this.filterResult = filterResult;
      },

      fetchFilterData(list, selected = false) {
        list.map((item) => {
          item.selected = selected;
          return item;
        });
        return list;
      },

      handleFilterTitle(name) {
        const selectFilterIndex = this.filterBar.findIndex(item => item.name === name);
        if (this.filterBar[selectFilterIndex].selected) {
          this.filterBar[selectFilterIndex].selected = false;
          this.handleFilterContentScroll();
          return;
        }
        this.fetchFilterData(this.filterBar);
        this.filterBar[selectFilterIndex].selected = true;
        this.handleFilterContentScroll(true);
      },

      handleFilterContentScroll(selected = false) {
        if (selected) {
          document.body.style.position = 'fixed';
          document.body.style.width = '100%';
        } else {
          document.body.style.position = 'static';
          document.body.style.width = 'auto';
        }
      },

      handleConfirm(data) {
        const params = Object.assign(this.filterResult, data);
        this.$emit('submit', params);
      },

      handleReset(data) {
        const keys = Object.keys(data);
        keys.forEach((item) => {
          if (item in this.filterResult) {
            delete this.filterResult[item];
          }
        });
        this.$emit('submit', this.filterResult);
      },

      handleDelete(data) {
        const key = data.split('=')[0];
        delete this.filterResult[key];
      },
    },
    created() {
      this.fetchProductFilterInfo(this.params);
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-filter-component {
    max-width: @size-ignore-max-width;
    display: flex;
    justify-content: space-between;
    height: 80px;
    line-height: 80px;
    border-bottom: @border-base;
  }

</style>
